import { useState, useEffect } from 'react';
import { useDropdown } from '@/contexts/DropdownContext';
import { DropdownOption } from '@/services/dropdownService';

interface UseDependentDropdownProps {
  parentKey: string;
  parentValue: string;
  dependentKey: string;
}

export const useDependentDropdown = ({ parentKey, parentValue, dependentKey }: UseDependentDropdownProps) => {
  const { getDependentOptions } = useDropdown();
  const [options, setOptions] = useState<DropdownOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadDependentOptions = async () => {
      if (!parentValue) {
        setOptions([]);
        setError(null);
        return;
      }

      setIsLoading(true);
      setError(null);

      try {
        const dependentOptions = await getDependentOptions(parentKey, parentValue, dependentKey);
        setOptions(dependentOptions);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load options');
        setOptions([]);
      } finally {
        setIsLoading(false);
      }
    };

    loadDependentOptions();
  }, [parentKey, parentValue, dependentKey, getDependentOptions]);

  return {
    options,
    isLoading,
    error,
  };
};

export default useDependentDropdown;
